module.exports = __webpack_public_path__ + "static/img/LV@2x.423f8cb5.jpg";